import React, { FC, useState } from 'react';

import { useTranslation } from '@modernloop/i18n';
import { TimezoneSelect } from '@modernloop/shared/components';
import { getLocalTimezone } from '@modernloop/shared/datetime';
import { Box, Stack, Table, TableBody, TableCell, TableRow, TextField } from '@mui/material';
import { format, fromZonedTime, toZonedTime } from 'date-fns-tz';

const TimezonesTab: FC = () => {
  const { t } = useTranslation();
  const [timezone, setTimezone] = useState(getLocalTimezone());
  const [isoTimestamp, setIsoTimestamp] = useState(new Date().toISOString());
  return (
    <Stack spacing={1}>
      <TextField
        id="app-dev-tools-modal-timezones-iso-timestamp"
        helperText={t('hiring-dashboard-dev-tools:dev-tools.timezones.isoTimestampHelper')}
        disabled
        value={isoTimestamp}
        onChange={(e) => setIsoTimestamp(e.target.value)}
        inputProps={{ 'data-testid': 'app-dev-tools-modal-timezones-iso-timestamp' }}
      />

      <Box id="app-dev-tools-modal-timezones-select" data-testid="app-dev-tools-modal-timezones-select">
        <TimezoneSelect value={timezone} onTimezoneChange={setTimezone} />
      </Box>
      <Table>
        <TableBody>
          <TableRow hover>
            <TableCell>{t('hiring-dashboard-dev-tools:dev-tools.timezones.browserTime')}</TableCell>
            <TableCell>{format(new Date(isoTimestamp), 'MMM, d yyyy HH:mm')}</TableCell>
          </TableRow>
          <TableRow hover>
            <TableCell>{t('hiring-dashboard-dev-tools:dev-tools.timezones.timezoneTime')}</TableCell>
            <TableCell>
              {format(
                toZonedTime(fromZonedTime(new Date(isoTimestamp), getLocalTimezone()), timezone),
                'MMM, d yyyy HH:mm'
              )}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Stack>
  );
};

export default TimezonesTab;
